export interface ElementItem {
    link: string;
    name: string;
}

export const elements: ElementItem[] = [
    {
        link: "/elements/accordions",
        name: "accordions"
    },
    {
        link: "/elements/banners",
        name: "banners"
    },
    {
        link: "/elements/blog-posts",
        name: "blog posts"
    },
    {
        link: "/elements/buttons",
        name: "buttons"
    },
    {
        link: "/elements/cta",
        name: "call to action"
    },
    {
        link: "/elements/icon-boxes",
        name: "icon boxes"
    },
    {
        link: "/elements/categories",
        name: "product categories"
    },
    {
        link: "/elements/products",
        name: "products"
    },
    {
        link: "/elements/tabs",
        name: "tabs"
    },
    {
        link: "/elements/testimonials",
        name: "testimonials"
    },
    {
        link: "/elements/titles",
        name: "titles"
    },
    {
        link: "/elements/typography",
        name: "typography"
    },
    {
        link: "/elements/video-banners",
        name: "video"
    }
]